import Layout from "../../../components/Layout";
import { Link } from "react-router-dom";
import { FilterContextProvider } from "../../../contexts/FilterContext";
import CreateOrderForm from "../../../components/order/Create";
import Chip from "../../../components/Chip";
import MessagePopup from "../../../components/MessagePopup";
import DataTable from "../../../components/DataTable";
import useData from "../../../hooks/useData";
import { EyeOpen } from "../../../assets/icons/Icons";
import { formatDate } from "../../../utils/formatDate";
import { useTranslation } from "react-i18next";
import CustomTooltip from "../../../components/CustomTooltip";
import ViewProgram from "../../../components/programs/View";
import FilterPrograms from "../../../api/program/filterPrograms";
import { useGlobalContext } from "../../../contexts/GlobalContext";
import { useEffect } from "react";

function Index(props) {
  const { t } = useTranslation();

  const {
    data,
    errorMessage,
    loadingData,
    pageCount,
    selectedItem,
    setSelectedItem,
    newItemAdded,
    setNewItemAdded,
    showCreateItem,
    setShowCreateItem,
    showViewItem,
    setShowViewItem,
  } = useData(FilterPrograms);

  const { setPageTitle, setBreadcrumbs } = useGlobalContext();

  useEffect(() => {
    setPageTitle(t("Card Issuing"));
    setBreadcrumbs([t("Card Issuing"), t("Programs")]);

    return () => {
      setPageTitle("");
      setBreadcrumbs([]);
    };
    // eslint-disable-next-line
  }, []);

  return (
    <Layout title={t("Programs")} breadcrumbs={t("Card Issuing")}>
      {showCreateItem && (
        <CreateOrderForm
          onClose={() => setShowCreateItem(false)}
          onCreate={(e) => {
            setShowCreateItem(false);
            setNewItemAdded(true);
          }}
        />
      )}
      {newItemAdded && (
        <MessagePopup
          title={t("Order Created!")}
          message={t("The order has been successfully created!")}
          onClose={(e) => setNewItemAdded(false)}
        />
      )}
      {showViewItem && (
        <ViewProgram
          program={selectedItem}
          onClose={() => setShowViewItem(false)}
        />
      )}

      <DataTable
        filtersTop={
          <FilterContextProvider name="s">
            {/* <SearchFilter /> */}
          </FilterContextProvider>
        }
        filtersBottom={
          <>
            {/* <FilterContextProvider name="date">
              <DateRangeFilter />
            </FilterContextProvider> */}
            {/* <FilterContextProvider name="id">
              <SearchFilter
                hideIcon
                placeholderText="ID"
                inputStyles={{ maxWidth: "140px" }}
              />
            </FilterContextProvider> */}
            {/* <FilterContextProvider name="office_id">
              <SearchFilter
                hideIcon
                placeholderText={t("Office ID")}
                inputStyles={{ maxWidth: "140px" }}
              />
            </FilterContextProvider> */}
            {/* <FilterContextProvider>
              <ResetFilters />
            </FilterContextProvider> */}
          </>
        }
        buttons={
          <>
            {/* {["admin", "office_admin", "client_admin"].includes(
              currentUser?.role`
            ) && (
              <button
                className="btn btn-primary btn-medium"
                onClick={(e) => setShowCreateItem(true)}
              >
                {t("Create")}
              </button>
            )} */}
          </>
        }
        columns={[
          { header: t("Program ID"), accessor: "id" },
          { header: t("Program Name"), accessor: "name" },
          {
            header: t("Direct Deposit Account"),
            accessor: "direct_deposit_account",
          },
          { header: t("Status"), accessor: "status" },
          {
            header: t("Master Funding Account Number"),
            accessor: "master_funding_account_number",
          },
          { header: t("Created Date"), accessor: "created_at" },
          { header: t("Action"), accessor: "actions" },
        ]}
        rows={data.data || []}
        pageCount={pageCount}
        loadingData={loadingData}
        error={errorMessage}
        actions={(item) => (
          <div className="d-flex align-items-center">
            <Link
              to="#"
              onClick={(e) => {
                e.preventDefault();
                setSelectedItem(item);
                setShowViewItem(true);
              }}
            >
              <CustomTooltip icon={<EyeOpen />} message={t("View")} />
            </Link>
          </div>
        )}
        customOutputs={(columnName, value) => {
          switch (columnName) {
            case "direct_deposit_account":
              return value ? t("Enabled") : t("Disabled");
            case "status":
              let status = value;
              return (
                <Chip
                  state={status}
                  label={status.charAt(0).toUpperCase() + status.slice(1)}
                  showAsTooltop
                />
              );
            case "created_at":
              return formatDate(value);
            default:
              return value;
          }
        }}
      />
    </Layout>
  );
}

export default Index;
